export default __webpack_public_path__ + "static/media/manage-allocation-collapse.0363ffb5.svg";